import React from 'react';
import MarketingLayout, { type ActivePage } from '../../marketing/layout/MarketingLayout';

/**
 * Adapter over the redesigned chrome in src/marketing/layout.
 *
 * Fourteen public pages import this file; keeping its path and props means
 * every one of them — enrolment with its minimal header and progress bar, the
 * thank-you page, waitlist, privacy, terms, campaign and referral landings —
 * picks up the new nav and footer without an import changing. Pages built
 * for the redesign import MarketingLayout directly.
 */

/** @deprecated The section anchors this addressed no longer exist; kept so old call sites compile. */
export type MarketingSectionId = 'how-it-works' | 'why-melio' | 'compare';

interface PublicMarketingLayoutProps {
  children: React.ReactNode;
  activePage?: ActivePage;
  /** @deprecated Ignored. */
  onSectionNavigate?: (sectionId: MarketingSectionId) => void;
  mainClassName?: string;
  /** Focused flow (e.g. enrolment): header shows the wordmark only, no nav. */
  minimalHeader?: boolean;
  /** 0–1 completion. When set, a thin bar fills left→right under the header. */
  progress?: number | null;
}

export default function PublicMarketingLayout({
  children,
  activePage = 'home',
  mainClassName = 'flex-1',
  minimalHeader = false,
  progress = null,
}: PublicMarketingLayoutProps) {
  return (
    <MarketingLayout activePage={activePage} mainClassName={mainClassName} minimalHeader={minimalHeader} progress={progress}>
      {children}
    </MarketingLayout>
  );
}
